import type { ExperimentId, ExperimentStatus } from "@globals";

export default function resolveExperimentLinkTo(id: ExperimentId, status: ExperimentStatus) {
  if (status === "draft") {
    return `/experiments/drafts/${id}`;
  } else {
    return `/experiments/${id}`;
  }
}
